import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environment/environment';

@Injectable()
export class StoreApiDataService {
   url = environment.url;

   constructor(private http: HttpClient){}

   //LIST
   public getStoreList(payload: any): Observable<any> {
    return this.http.post(`${this.url}get/store`, payload);
   }
}